import { render, staticRenderFns } from "./SendDocumentTemplate.vue?vue&type=template&id=2e0b147e&"
import script from "./SendDocumentTemplate.vue?vue&type=script&lang=js&"
export * from "./SendDocumentTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e0b147e')) {
      api.createRecord('2e0b147e', component.options)
    } else {
      api.reload('2e0b147e', component.options)
    }
    module.hot.accept("./SendDocumentTemplate.vue?vue&type=template&id=2e0b147e&", function () {
      api.rerender('2e0b147e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/requests/creationPages/SendDocumentTemplate.vue"
export default component.exports